<template>
  <v-container class="wrapper">
    <div class="text-center">
      <h1 class="text-h4 mt-2">
        My Favourite Candidates
      </h1>
    </div>
      <v-container>
        <v-row>
          <v-col
            cols="6"
            xl="6"
            lg="6"
            md="6"
            sm="12"
            xs="12"
            v-for="person in persons"
            :key="person"
          >
            <v-card min-height="10" max-width="830">
              <div class="pa-2">
                <v-avatar size="100" class="display-inline">
                  <v-img
                    :src="
                      VUE_APP_API_ENDPOINT +
                      'images/profiles/' +
                      (person.image || 'default.jpg')
                    "
                  >
                  </v-img>
                </v-avatar>

                <v-card-title class="ma-2 pa-0">{{
                  person.full_name
                }}</v-card-title>
                <v-card-title class="ma-2 pa-0"
                  ><a :href="'mailto:' + person.email">{{
                    person.email
                  }}</a></v-card-title>
                <v-spacer></v-spacer>

                <v-btn
                  block
                  class="button-gradient-half"
                  @click.stop="(dialog = true), (selectedPerson = person)">
                  Details
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title class="text-h5">
          Details for {{ selectedPerson.full_name }}
        </v-card-title>

        <v-card-text>
          <p v-if="selectedPerson.cv">
            CV: <a :href="VUE_APP_API_ENDPOINT + 'cvs/' + selectedPerson.cv" target="blank">{{ selectedPerson.cv }}</a>
          </p>
          <p v-if="selectedPerson.description">
            Description: {{ selectedPerson.description }}
          </p>
          <p v-if="selectedPerson.country">
            Country: {{ selectedPerson.country }}
          </p>
          <p v-if="selectedPerson.state">State: {{ selectedPerson.state }}</p>
          <p v-if="selectedPerson.city">City: {{ selectedPerson.city }}</p>
          <p v-if="selectedPerson.phone">Phone: {{ selectedPerson.phone }}</p>
          <p v-if="selectedPerson.email">Email: <a :href='"mailto: " + selectedPerson.email'>{{ selectedPerson.email }}</a></p>
          <p v-if="selectedPerson.userProfile">
            Skills: {{ selectedPerson.userProfile.skills.join(", ") }}
          </p>
          <p v-if="selectedPerson.userProfile">
            Competences: {{ selectedPerson.userProfile.competences.join(", ") }}
          </p>
          <p v-if="selectedPerson.userProfile">
            Experiences: {{ selectedPerson.userProfile.experiences.join(", ") }}
          </p>
          <div v-if="selectedPerson.userProfile">
            Educations:
            <div
              v-for="education in selectedPerson.userProfile.educations"
              :key="education.users_educations_id"
            >
              &nbsp;Name: {{ education.name }}<br />
              &nbsp;Level: {{ education.level }}<br />
              &nbsp;University {{ education.university }}<br />
              &nbsp;Start Year: {{ education.start_year }}<br />
              &nbsp;End year: {{ education.end_year }}
            </div>
            <br />
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn color="green darken-1" text>
            Add to favorites
          </v-btn> -->
              <v-btn  class="button-gradient-error-half" @click="deleteToFav">Remove From Favorites</v-btn>
              <v-btn  class="button-gradient-half" text @click="dialog = false">Close</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar_show" :color="snackbar_color" top :timeout="1500">
      <v-icon>{{ snackbar_icon }}</v-icon>
      {{ snackbar_text }}
    </v-snackbar>
  </v-container>
</template>

<script>
const { escoAutocompleteFetchInit } = require("../../../lib/catalog-autocomplete");
export default {
  name: "SearchCandidates",
  data() {
    return {
      persons: [],
      selectedPerson: {},
      // Skills
      skillsAutocompleteLoading: false, // Loading animation autocomplete
      skillsAutocompleteSearch: [], // Results of the skills search autocomplete
      skillAutocompleteSearch: null, // Autocomplete search field
      skillsSelectedAutocomplete: [], // Autocomplete skills selected
      // Competences
      competencesAutocompleteLoading: false, // Loading animation autocomplete
      competencesAutocompleteSearch: [], // Results of the competences search autocomplete
      competenceAutocompleteSearch: null, // Autocomplete search field
      competencesSelectedAutocomplete: [], // Autocomplete competences selected
      // Experiences
      experiencesAutocompleteLoading: false, // Loading animation autocomplete
      experiencesAutocompleteSearch: [], // Results of the experiences search autocomplete
      experienceAutocompleteSearch: null, // Autocomplete search field
      experiencesSelectedAutocomplete: [], // Autocomplete experiences selected
      // Snackbar
      snackbar_show: false,
      snackbar_color: null,
      snackbar_text: null,
      snackbar_icon: null,
      // User details dialog
      dialog: false,
      // env
      VUE_APP_API_ENDPOINT: process.env.VUE_APP_API_ENDPOINT,
    };
  },
  watch: {
    skillAutocompleteSearch(name) {
      name && name !== this.select && this.searchSkillsByName(name);
    },
    competenceAutocompleteSearch(name) {
      name && name !== this.select && this.searchCompetencesByName(name);
    },
    experienceAutocompleteSearch(name) {
      name && name !== this.select && this.searchExperiencesByName(name);
    },
  },
  async mounted() {
   try {
      this.persons = await this.getFavCandidates();
    } catch (error) {
      if (error.message.includes("Authentication failed")) {
        this.$router.push("/auth-error");
      }
    }
  },
  methods: {

    async getFavCandidates(){
      let personsFound
      try {
        personsFound = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "company/candidates",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            }
          }
        );

        personsFound = await personsFound.json();
        this.persons = personsFound.result;
        console.log(this.persons)
        if (this.persons.length === 0) {
          this.snackbar_text = "No candidates found";
          this.snackbar_icon = "mdi-alert-circle";
          this.snackbar_show = true;
        }
        return this.persons;
      } catch (error) {
        // Error message
        this.snackbar_color = "error";
        this.snackbar_text = error.message;
        this.snackbar_icon = "mdi-alert-circle";
        this.snackbar_show = true;
      }
    },
    async deleteToFav(){
        //console.log(this.selectedPerson)
        let result
        try {
          //console.log("EL ID ES: " + JSON.stringify(this.selectedPerson))
          result = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "company/deleteCandidates",
          {
            method: "POST",
            body: JSON.stringify({candidateId: this.selectedPerson.user_id}),
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
          }
        );
        console.log(result)
        if (result.status == 200){
            this.snackbar_color = "success";
            this.snackbar_text = "Candidated deleted from favorites";
            this.snackbar_icon = "mdi-alert-circle";
            this.snackbar_show = true;
            location.reload()
        }
        return this.persons;
      } catch (error) {
        // Error message
        this.snackbar_color = "error";
        this.snackbar_text = error.message;
        this.snackbar_icon = "mdi-alert-circle";
        this.snackbar_show = true;
      }
    },

    async searchCandidates() {
      let personsFound;
      try {
        personsFound = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "v2/common/search-candidates",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Auth-Token": this.$cookie.get("jwt_token"),
            },
            body: JSON.stringify({
              skills: this.skillsSelectedAutocomplete,
              competences: this.competencesSelectedAutocomplete,
              experiences: this.experiencesSelectedAutocomplete,
            }),
          }
        );
        personsFound = await personsFound.json();
        console.log(personsFound)
        this.persons = personsFound.result;
        if (this.persons.length === 0) {
          this.snackbar_text = "No candidates found";
          this.snackbar_icon = "mdi-alert-circle";
          this.snackbar_show = true;
        }
        return this.persons;
      } catch (error) {
        // Error message
        this.snackbar_color = "error";
        this.snackbar_text = error.message;
        this.snackbar_icon = "mdi-alert-circle";
        this.snackbar_show = true;
      }
    },
    async searchSkillsByName(name) {
      let response;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT + "v2/common/search-skills-by-name",
          escoAutocompleteFetchInit(this, { name })
        );
        response = await response.json();
      } catch (error) {
        console.log(error.message);
      }
      this.skillsAutocompleteLoading = false;
      this.skillsAutocompleteSearch = response.result;
    },
    async searchCompetencesByName(name) {
      let response;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT +
            "v2/common/search-competences-by-name",
          escoAutocompleteFetchInit(this, { name })
        );
        response = await response.json();
      } catch (error) {
        console.log(error.message);
      }
      this.competencesAutocompleteLoading = false;
      this.competencesAutocompleteSearch = response.result;
    },
    async searchExperiencesByName(name) {
      let response;
      try {
        response = await fetch(
          process.env.VUE_APP_API_ENDPOINT +
            "v2/common/search-experiences-by-name",
          escoAutocompleteFetchInit(this, { name })
        );
        response = await response.json();
      } catch (error) {
        console.log(error.message);
      }
      this.experiencesAutocompleteLoading = false;
      this.experiencesAutocompleteSearch = response.result;
    },
  },
};
</script>

<style scoped>

.wrapper {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 40px;
}

.no-link {
  text-decoration: none;
  color: black;
}
.card-title {
  word-break: normal;
  margin-bottom: 20px;
  font-weight: bold;
}
.bold {
  font-weight: bold;
}
.gray {
  color: #283444;
}

.button-gradient-half:hover {
  background-position: right center;
}

.button-gradient-half {
  text-align: center;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  /* text-shadow: 0px 0px 10px rgba(0,0,0,0.2);*/
  box-shadow: 0 0 20px #eee;
  border-radius: 7px;
  /* Yellow and orange background-image: linear-gradient(to right, #F2E500 0%, #EC6608 51%, #F2E500 100%); */
  background-image: linear-gradient(to right, #047ec3 0%, #52ae32 100%);
}

.button-gradient-error-half:hover {
  background-position: right center;
}
.button-gradient-error-half {
  text-align: center;
  transition: 0.5s;
  background-size: 200% auto;
  color: white;
  /* text-shadow: 0px 0px 10px rgba(0,0,0,0.2);*/
  box-shadow: 0 0 20px #eee;
  border-radius: 7px;
  background-image: linear-gradient(to right, #ec6608 0%, #f2e500 150%);
}

</style>
